<template>
  <div class="about">
    name: {{ knowledge_process.name }}<br />
    description: {{ knowledge_process.description }}
    <br />
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['knowledge_process'],
  created () {
      
  },
  watch: {
      
  },
  methods: {
  },
  components: {
  }
}
</script>
<style>
.process_step_card {
    margin-bottom: 10px;
}
.col-maxwidth {
    max-width: 300px;
}
</style>